import { TDataCloneErrorFactory } from '../types';

export const createDataCloneError: TDataCloneErrorFactory = () => new DOMException('', 'DataCloneError');
